<div class="global-filters-form-block" [ngClass]="{'row' : config.displayAxis === 'y'}">
  @if (config.label) {
    <span class="global-filters-form-block-label">{{config.label | translate}}</span>
  }
  <mat-form-field appearance="fill" class="global-filters-dropdown">
    <mat-select [(value)]="config.initialOptionValue" (selectionChange)="onChange($event)">
      @if (config.hasNullOption) {
        <mat-option [value]="null">
          {{''}}
        </mat-option>
      }
      @for (option of config.options; track option) {
        <mat-option [value]="option.value">
          {{option.key | translate}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
